import { createSelector } from 'reselect';

import { AdditionalFilter } from '../components/GridScreenTitle/GridScreenTitle';
import { CampaignsCalcTypeFilter } from '../typings/domain';
import { FilterPartialExpression } from '../typings/filter';
import { PeriodFilterValue } from '../typings/filters';
import { GridSelectionInfo, GridSourceParams } from '../typings/grid';
import { State } from '../typings/state';

import {
    selectGridAdditionalFilter,
    selectGridFilterExpressions,
    selectStatPeriodFilterValue
} from './grid/grid';
import { selectGridSourceParams } from './gridSourceParams/gridSourceParams';

export const selectGridSourceParamsViewForMetrika = createSelector(
    selectGridSourceParams,
    (sourceParams?: GridSourceParams) =>
        sourceParams ? sourceParams.view : undefined
);

export const selectSortParamsForMetrika = createSelector(
    selectGridSourceParams,
    (sourceParams?: GridSourceParams) => {
        if (!sourceParams) {
            return '';
        }

        const { sortParams } = sourceParams;

        return sortParams ? `${sortParams.key}-${sortParams.direction}` : '';
    }
);

export const selectGridAdditionalFilterForMetrika = createSelector(
    selectGridAdditionalFilter,
    (additionalFilter?: AdditionalFilter) =>
        additionalFilter ? additionalFilter.additionalFilterValue : undefined
);

export const selectStatPeriodValueForMetrika = createSelector(
    selectStatPeriodFilterValue,
    (value: PeriodFilterValue = {}) => {
        const { dateRangePreset = '', dateFrom, dateTo } = value;

        let statPeriodFilter = dateRangePreset;

        if (dateFrom && dateTo) {
            statPeriodFilter = `${dateFrom.format(
                'YYYY-MM-DD'
            )}-${dateTo.format('YYYY-MM-DD')}`;
        }

        return statPeriodFilter;
    }
);

export const selectGridFilterExpressionsForMetrika = createSelector(
    selectGridFilterExpressions,
    (fitlerExpressions: FilterPartialExpression[]) => ({
        filter: fitlerExpressions.reduce((acc, el) => {
            acc[`${el.field}-${el.operator}`] = true;
            return acc;
        }, {})
    })
);

export const selectCalcTypeForMetrika = createSelector(
    (state: State) => state.grid.campaignsCalcTypeFilter,
    (calcTypeFilter: CampaignsCalcTypeFilter) => calcTypeFilter
);

export const selectSelectionForMetrika = createSelector(
    (state: State) => state.grid.selectionInfo,
    (selection: GridSelectionInfo) => ({
        selection: {
            campaigns: selection.campaigns.length,
            groups: selection.groups.length,
            phrases: selection.phrases.length,
            feedFilters: selection.feedFilters.length
        }
    })
);

export const selectGridCompactViewForMetrika = createSelector(
    (state: State) => state.grid.isCompactViewEnabled,
    (isCompactViewEnabled: boolean) => isCompactViewEnabled
);
